export function isPromise(p) {
    return p?.then != null;
}
//# sourceMappingURL=is-promise.js.map